import styled from 'styled-components';

export const LoadOuter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const MarginTop = {
  marginTop: 20,
};
